import { Modal } from "antd";
import React, { useState, ReactNode } from "react";

interface ModalConfirmProps {
  title: string;
  description: string;
  okText?: string;
  open: boolean;
  onCancel?: () => void;
  onOk?: () => Promise<void> | void;
  detail?: ReactNode; // Allow passing HTML/JSX
  width?: number | string; // Add width prop
  isProceed?: boolean
}

const ModalConfirm: React.FC<ModalConfirmProps> = ({
  title,
  description,
  okText = 'Proceed',
  open,
  onCancel,
  onOk,
  detail,
  width, // Destructure width
  isProceed = true,
}) => {
  const [loading, setLoading] = useState(false);

  const handleOk = async () => {
    if (!onOk) return;
    try {
      setLoading(true);
      await onOk();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onCancel}
      onOk={handleOk}
      okText={okText}
      confirmLoading={loading}
      width={width} // Pass width to Modal
      okButtonProps={{
        style: { display: isProceed ? "inline-block" : "none" },
      }}
    >
      <p style={{ fontSize: 20 }}>{description}</p>
      {detail}
    </Modal>
  );
};

export default ModalConfirm;
